import {PopoverAttachmentType} from "./@const";

export type PopoverPositionConfig = {
    attachment              : string
    targetAttachment        : string
    targetOffset            : string
    attachmentType          : PopoverAttachmentType, // full' | 'horizontal' | 'vertical'         //string, //full, horizontal, vertical
    constraints?            : any
    offset?                 : string // no idea yet what it does
}

export default class PopoverPosition {

    public attachment           : string
    public targetAttachment     : string
    public targetOffset         : string
    public offset               : string
    public attachmentType       : PopoverAttachmentType // 'full' | 'horizontal' | 'vertical'         //string, //full, horizontal, vertical

    public constrains           : any // popoverConstraints

    constructor(config: PopoverPositionConfig) {

        this.attachment         = config?.attachment
        this.targetAttachment   = config?.targetAttachment
        this.targetOffset       = config?.targetOffset || "0 0"
        this.offset             = config?.offset || "0 0"
        this.attachmentType     = config?.attachmentType

        this.constrains         = config?.constraints

        // const popoverConstraints = [{
        //     to          : "window",
        //     attachment  : "together",
        //     pin         : true,
        // }];

    }

    // Experimental
    static bottomLeft(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top left",
            targetAttachment   : "bottom left",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.FULL
        })
    }

    static bottomLeftHorizontal(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top left",
            targetAttachment   : "bottom left",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.HORIZONTAL
        })
    }

    static bottomCenter(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top center",
            targetAttachment   : "bottom center",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.HORIZONTAL
        })
    }

    static bottomRight(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top right",
            targetAttachment   : "bottom right",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.HORIZONTAL
        })
    }

    static right(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top left",
            targetAttachment   : "top right",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.FULL
        })
    }

    static leftTop(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top right",
            targetAttachment   : "top left",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.VERTICAL
        })
    }

    static leftCenter(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "center right",
            targetAttachment   : "center left",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.VERTICAL
        })
    }

    static top(offset:string="0 0"):PopoverPosition {
        return new PopoverPosition({
            attachment         : "top center",
            targetAttachment   : "bottom center",
            targetOffset       : offset,
            attachmentType     : PopoverAttachmentType.FULL
        })
    }


}
